var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9 13.3L8.40002 1.29999C8.30002 0.999993 8.00002 0.899993 7.80002 1.09999C7.70002 1.09999 7.60002 1.19999 7.60002 1.29999L1.10002 13.3C1.00002 13.5 1.00002 13.6 1.10002 13.8C1.20002 13.9 1.30002 14 1.50002 14H14.5C14.7 14 14.8 13.9 14.9 13.8C15 13.6 15 13.4 14.9 13.3ZM7.40002 5.49999H8.50002V9.49999H7.40002V5.49999ZM8.00002 12.2C7.60002 12.2 7.20002 11.9 7.20002 11.4C7.20002 10.9 7.50002 10.6 8.00002 10.6C8.40002 10.6 8.80002 10.9 8.80002 11.4C8.80002 11.9 8.40002 12.2 8.00002 12.2Z",
    fill: "#9E6C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.780ab7cc46c3de560c9d500ac5382d2a.svg";
export { ForwardRef as ReactComponent };